import { render, staticRenderFns } from "./trunks-table-ips.vue?vue&type=template&id=03844957&"
import script from "./trunks-table-ips.vue?vue&type=script&lang=js&"
export * from "./trunks-table-ips.vue?vue&type=script&lang=js&"
import style0 from "./trunks-table-ips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports